import { render, staticRenderFns } from "./claim-summary-sections.vue?vue&type=template&id=c1ead0be&"
import script from "./claim-summary-sections.vue?vue&type=script&lang=ts&"
export * from "./claim-summary-sections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports